import { apiRequest, withToken } from './http-client';

export const customerCreate = async ( token, data ) => {
    return apiRequest({
        method: 'post',
        url: '/customer/',
        headers: withToken(token),
        data
    }, 'No se pudo validar la sesión');
}

export const getCustomer = async ( token, params = {} ) => {
    return apiRequest({
        method: 'get',
        url: '/customer/',
        headers: withToken(token),
        params
    }, 'No se pudo validar la sesión');
}

export const searchCustomer = async ( token, params = {} ) => {
    return apiRequest({
        method: 'get',
        url: '/customer/search',
        headers: withToken(token),
        params
    }, 'No se pudo validar la sesión');
}

export const getCustomerById = async ( token, customerId, params = {} ) => {
    return apiRequest({
        method: 'get',
        url: `/customer/${customerId}`,
        headers: withToken(token),
        params
    }, 'No se pudo validar la sesión');
}

export const updateCustomer = async ( token, customerId, data ) => {
    return apiRequest({
        method: 'patch',
        url: `/customer/${customerId}`,
        headers: withToken(token),
        data
    }, 'No se pudo validar la sesión');
}   
